import { render, staticRenderFns } from "./order-details.vue?vue&type=template&id=b089deaa&scoped=true"
import script from "./order-details.vue?vue&type=script&lang=js"
export * from "./order-details.vue?vue&type=script&lang=js"
import style0 from "./order-details.vue?vue&type=style&index=0&id=b089deaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b089deaa",
  null
  
)

export default component.exports